import { totalTimeFormat } from '../../utils/dateFormat';
import { getMinutesFromTimeInput } from '../../utils/timeCalc'
export function OvertimeDisplay({ data, dateTimeRules, config, _total_hours_overtime, t, total_hours_overtime = 0, ismultitasklog = false }) {
    const overtimes = [];
    if (ismultitasklog && total_hours_overtime) {
        return (
            <div style={{ lineHeight: '10px', fontSize: '10px' }}>
                <div className='d-flex flex-column'>
                    {totalTimeFormat(total_hours_overtime, dateTimeRules)}
                </div>
            </div>
        )
    }

    if (config.client.data.basicRules.overtimeAutomaticMode && _total_hours_overtime && !config.client.allow_company_shifts) {
        return (
            <div style={{ lineHeight: '10px', fontSize: '9px' }}>
                <div className='d-flex flex-column'>
                    <div>{t('Automatic')}</div>
                    {config.client.data.basicRules.overtimeCalcRules.calc_percent}%: {totalTimeFormat(_total_hours_overtime, dateTimeRules)}
                </div>
            </div>
        )
    }
    if (!data) {
        return null;
    }
    Object.keys(data).forEach(key => {
        overtimes.push(data[key]);
    });
    return (
        <div style={{ lineHeight: '10px', fontSize: '10px' }}>
            {overtimes.map((row, index) => (
                <div key={index}>
                    {row.name}: {totalTimeFormat(getMinutesFromTimeInput(row.value), dateTimeRules)}
                </div>
            ))}
        </div>
    );
}

export function WeeklyOvertimeDisplay({ data, dateTimeRules, ismultitasklog, total_hours_overtime, t }) {
    if (!data || !data.weekly_overtimes) return null;
    if (ismultitasklog && total_hours_overtime) return null;
    const overtimes = Object.values(data.weekly_overtimes);
    if (!overtimes.length) return null;


    return (
        <div style={{ lineHeight: '10px', fontSize: '10px', marginTop: '2px' }}>
            {overtimes.map((row, index) => (
                <div key={index}>
                    {row.name}: {totalTimeFormat(getMinutesFromTimeInput(row.value), dateTimeRules)}
                </div>
            ))}
        </div>
    );
}
